import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BASE_URL || "https://ruumies-vfd-nodejs-engine-juft.vercel.app";

export const sendOtp = async (email) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/auth/send-otp`, { email });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const verifyOtp = async (email, otp) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/auth/verify-otp`, { email, code:otp });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const resendOtp = async (email) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/auth/send-otp`, { email });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};